import { useParams, Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "../components/Seo";
import Breadcrumbs from "../components/Breadcrumbs";
import { BookButton, WhatsAppButton } from "../components/CTAButtons";
import { TOPIC_PAGES, SERVICES } from "../data/content";
import { breadcrumbSchema, multiGraph } from "../components/Schema";
import ServicesIndex from "./ServicesIndex";
import NotFound from "./NotFound";

export default function TopicPage({ onBook }) {
  const { slug } = useParams();
  const topic = TOPIC_PAGES[slug];
  if (!topic) return <NotFound />;

  // Special-case: services landing page renders the full grid
  if (slug === "spa-services-bhubaneswar") return <ServicesIndex onBook={onBook} />;

  const crumbs = [{ label: "Home", href: "/" }, { label: topic.title }];
  const related = (topic.related || [])
    .map((r) => TOPIC_PAGES[r])
    .filter(Boolean);

  return (
    <>
      <Seo
        title={topic.seoTitle}
        description={topic.description}
        path={`/${slug}/`}
        jsonLd={multiGraph(breadcrumbSchema(crumbs))}
      />
      <section className="content-hero section-pad narrow">
        <Breadcrumbs items={crumbs} />
        <p className="eyebrow">Spa Near Me Bhubaneswar</p>
        <h1>{topic.hero}</h1>
        <p className="large-copy">{topic.intro}</p>
        <div className="actions-row">
          <BookButton onBook={onBook} label="Start enquiry" testid="topic-book-cta" />
          <WhatsAppButton label="WhatsApp our partner" source={`topic_${slug}`} testid="topic-whatsapp-cta" />
        </div>
      </section>

      {topic.sections && topic.sections.length > 0 && (
        <section className="section-pad narrow topic-body">
          {topic.sections.map((sec, idx) => (
            <div key={idx} className="topic-section">
              <h2>{sec.h}</h2>
              {sec.body.map((p, i) => (
                p.endsWith("?") || p.length < 90 ? (
                  <p key={i} className="large-copy bullet">• {p}</p>
                ) : (
                  <p key={i} className="large-copy">{p}</p>
                )
              ))}
            </div>
          ))}
        </section>
      )}

      <section className="section-pad featured-services-strip">
        <h2>Services you might consider</h2>
        <div className="service-grid">
          {SERVICES.slice(0, 4).map((s, i) => (
            <Link to={`/services/${s.slug}/`} className="service-card" key={s.slug} data-testid={`topic-service-${i}`}>
              <div className="service-photo" style={{ backgroundImage: `url(${s.image})` }} />
              <div className="service-card-copy">
                <span className="card-kicker">{s.kicker}</span>
                <h3>{s.name}</h3>
                <p>{s.short}</p>
                <ArrowRight size={18} />
              </div>
            </Link>
          ))}
        </div>
      </section>

      {related.length > 0 && (
        <section className="section-pad related-topics">
          <h2>Keep reading</h2>
          <div className="topics-grid">
            {related.map((r, i) => {
              const rSlug = Object.keys(TOPIC_PAGES).find((k) => TOPIC_PAGES[k] === r);
              return (
                <Link key={rSlug} to={`/${rSlug}/`} className="topic-chip" data-testid={`related-topic-${i}`}>
                  {r.title} <ArrowRight size={14} />
                </Link>
              );
            })}
          </div>
        </section>
      )}
    </>
  );
}
